import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { numToDecimalString, numToCurrency } from "./utils/transformators";

const USPosMatchingToolTip = ({ listlength, itemindex, usposnumber, usposmatchnumber, url }) => {
  //general
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  //states
  const [usposmatchdata, setUSPosmatchdata] = useState();
  //classNames
  let showHidePosTooltip;
  if (listlength > 8) {
    if (itemindex > 5) {
      showHidePosTooltip = usposnumber === usposmatchnumber ? "postooltip" : "postooltip display-none";
    }
    if (itemindex <= 5) {
      showHidePosTooltip = usposnumber === usposmatchnumber ? "postooltip top-position" : "postooltip display-none";
    }
  } else {
    showHidePosTooltip = usposnumber === usposmatchnumber ? "postooltip" : "postooltip display-none";
  }

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await axiosPrivate.post(`/api/positions/${url}`, { usposnumber: usposnumber });
        setUSPosmatchdata(response.data);
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    if (usposnumber && usposmatchnumber && usposnumber === usposmatchnumber) {
      fetchdata();
    }
  }, [usposmatchnumber]);
  return (
    <span className={showHidePosTooltip}>
      <h4>Matching Sales for Lot {usposnumber}</h4>
      <ul>
        <li className='posmatchitem'>
          <h4>WGS</h4>
          <h4>Trader</h4>
          <h4>Customer</h4>
          <h4>Qty(mt)</h4>
          <h4>Qty(pallets)</h4>
          <h4>Sales Price(pmt)</h4>
          <h4>Profit(pmt)</h4>
        </li>
        {usposmatchdata
          ? usposmatchdata.map((item) => (
              <li className='posmatchitem'>
                <p>{item.WGS}</p>
                <p>{item.trader}</p>
                <p>{item.customer}</p>
                <p>{numToDecimalString(Number(item.quantity))}</p>
                <p>{numToDecimalString(Number(item.numpallets))}</p>
                <p>{numToCurrency(Number(item.salesprice))}</p>
                <p>{numToCurrency(Number(item.profitpmt))}</p>
              </li>
            ))
          : "No matching data."}
      </ul>
    </span>
  );
};

export default USPosMatchingToolTip;
